import type * as Pincerjs from "pincerjs";

/*
The app, compiled from Kotlin (pincer/pincerjs), is loaded by its own <script> before the client's script, and defines
the global `pincerjs`. Its types are generated from pincer/pincerjs/src/jsMain/kotlin/PincerJs.kt.
*/
declare global {
  const pincerjs: typeof Pincerjs;
  // Set by build.mjs: false while developing
  const PRODUCTION: boolean;
}

// The pincer in the address (#PIDPIDPIDPID), if the page was opened with one
export function initialLocation(): string {
  return location.hash.length === 13 ? location.hash.substring(1) : "";
}
